<ng-container>
  <div class="flex flex-col gap-[24px]">
    <div class="flex flex-row justify-between items-center">
      <div class="flex flex-row gap-[24px] lt-md:gap-[16px] justify-start items-center">
        <mat-icon>menu</mat-icon>
        <h3 class="app-ellipsis">
          {{
            otherRoom?.properties?.name?.value || '+INSTALLATIONS.SRC.OTHER_ROOM.TITLE' | translate
          }}
        </h3>
        <div
          class="toggle-wrapper"
          [class.disabled]="!enabled"
          [viConfirm]="{
            title:
              (active
                ? '+INSTALLATIONS.INSTALLATION.OTHERROOMS.DEACTIVATION.MODAL.TITLE'
                : '+INSTALLATIONS.INSTALLATION.OTHERROOMS.ACTIVATION.MODAL.TITLE'
              ) | translate,
            content:
              (active
                ? '+INSTALLATIONS.INSTALLATION.OTHERROOMS.DEACTIVATION.MODAL.CONTENT'
                : '+INSTALLATIONS.INSTALLATION.OTHERROOMS.ACTIVATION.MODAL.CONTENT'
              ) | translate,
            cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
            confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
          }"
          gtm="onToggle"
          gtmAction="Other Room"
          gtmCategory="commissioningOverview"
          (confirm)="toggleOtherRoom(active)"
          (cancel)="cancelToggleOtherRoom()"
        >
          <mat-slide-toggle
            #otherRoomToggle
            [disabled]="!enabled"
            [checked]="active && otherRoom?.isEnabled"
            (change)="onOtherRoomSwitchChange(otherRoomToggle)"
          ></mat-slide-toggle>
        </div>
      </div>
      <div>
        <button
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Edit room modal"
          gtmCategory="otherRooms"
          data-at-comissioning-icon-edit-other-room
          class="edit-btn"
          (click)="commissioningService.openEditRoomDialog(otherRoom, true)"
        >
          <mat-icon>edit</mat-icon>
          <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="offset flex flex-col gap-[24px] lt-md:gap-[8px]">
      <app-feature-details-grid *ngIf="heatingCircuit as hc" class="feature-details-grid">
        <app-feature-list-container>
          <app-feature-list-item
            data-at-circuit-name
            [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
            [value]="installationService.getCircuitName(heatingCircuit) | async"
          >
          </app-feature-list-item>
        </app-feature-list-container>

        <app-banner *ngIf="!enabled" [type]="'warning'">
          {{ '+COMMISSIONING.OVERVIEW.TOOLTIP.OTHER_ROOMS_DISABLED' | translate }}
        </app-banner>
      </app-feature-details-grid>
    </div>
  </div>
</ng-container>
